import { createFileRoute } from '@tanstack/react-router'
import { emptySearchSchema } from '../../src/schemas/routeSchemas'

export const Route = createFileRoute('/login')({
  validateSearch: (search) => emptySearchSchema.parse(search),
  loaderDeps: () => ({}),
  staticData: {
    englishAllowed: true,
  },
})
